import req from "@/assets/js/axios"
/* 科技mall*/
export default {
    //用户查询申请  
    getApply: (params) => {
        return req.apiAxios("POST", '/apply/ApplyController/starry-security/getApply', params)
    },
    //条件查询楼盘（前台）
    getBuildings: (params) => {
        return req.apiAxios("POST", '/building/BuildingController/getBuildings', params)
    },
    //用户提交申请
    submitApply: (params) => {
        return req.apiAxios("POST", '/business/apply/BApplyController/starry-security/submitApply', params)
    },
     // 用户撤回(放行，空调，二次装修，撤离)
    withdrawApply: (params) => {
        return req.apiAxios("POST",'/business/apply/BApplyController/starry-security/withdraw', params);
    },
    // 获取园区配置信息
    getIncubatorConfig: (params) => {
        return req.apiAxios("POST",'/business/home/BHomeController/getIncubatorConfig', params);
    },
}